module.exports = __webpack_public_path__ + "img/dyx-icon.2c316990.png";